'use strict';

module.exports = require('./es2015');



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.findindex/~/es-abstract/es6.js
// module id = 206
// module chunks = 2